/** @format */

import React from "react";

function Posts({ newslettersData, handleClick }) {
  return (
    <section className="newsletter-post-archive">
      <div className="container">
        <div className="row">
          {newslettersData
            .map(
              (data) =>
                data?.type === "newsletter" && (
                  <div className="newsletters-post-grid" key={data.url}>
                    <div
                      onClick={() => {
                        handleClick(`${data.url}`);
                      }}
                    >
                      {/* <a
                      href={data.url}
                      target={data.sameTab ? "_self" : "_blank"}
                      rel="noopener noreferrer"
                    > */}
                      <article className="newsletters-grid">
                        <div className="feature-image">
                          <img
                            alt={data.title}
                            src={
                              !new Set(["webp", "svg"]).has(
                                data.image.split(".")[1]
                              )
                                ? require(`../../../../assets/${data.image}`)
                                    .default
                                : require(`../../../../assets/${data.image}`)
                            }
                          />
                        </div>
                        <div className="newsletters-content">
                          <a
                            href={data.url}
                            target="_blank"
                            className="newsletters-title"
                            rel="noopener noreferrer"
                          >
                            {data.title1
                              ? data.title1.replace("Newsletter", "")
                              : data.title.replace("Newsletter", "")}
                          </a>
                          <div className="newsletters-badge">{data.type}</div>
                        </div>
                      </article>
                      {/* </a> */}
                    </div>
                  </div>
                )
            )
            .reverse()}
        </div>
      </div>
    </section>
  );
}

export default Posts;
